/**
 * Coordinate bounds, checked on the form as well as on the backend.
 *
 * A pinned pair outside these ranges is refused by the API with
 * `invalid_payload`; catching it here tells the admin which field is wrong
 * instead of showing a generic refusal after a round trip.
 */

export const LATITUDE_LIMIT = 90;
export const LONGITUDE_LIMIT = 180;

export const isLatitudeInRange = (latitude: number): boolean =>
  Number.isFinite(latitude) && latitude >= -LATITUDE_LIMIT && latitude <= LATITUDE_LIMIT;

export const isLongitudeInRange = (longitude: number): boolean =>
  Number.isFinite(longitude) && longitude >= -LONGITUDE_LIMIT && longitude <= LONGITUDE_LIMIT;

export const isCoordinatePairInRange = (latitude: number, longitude: number): boolean =>
  isLatitudeInRange(latitude) && isLongitudeInRange(longitude);

export const parseCoordinate = (value: string): number | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};
